<template>
  <v-sheet v-if="$device.isDesktop" class="d-flex flex-column align-center condensed" width="100px">
    <v-avatar size="36" color="primary" class="font-weight-bold">
      {{ userStore.getInitials() }}
    </v-avatar>
    <span class="d-inline-block text-caption text-truncate" style="max-width: 100px">{{
        userStore.getDisplayName()
      }}</span>
  </v-sheet>
  <v-sheet v-else class="d-flex flex-row align-center w-100 space px-2 pt-2 ga-2">
    <v-avatar size="36" color="primary" class="font-weight-bold">
      {{ userStore.getInitials() }}
    </v-avatar>
    <span class="d-inline-block text-caption text-truncate">{{
        userStore.getDisplayName()
      }}</span>
  </v-sheet>
</template>
<script setup lang="ts">
const userStore = useUserStore()
</script>
